import { NmWebSection } from '../../../shared/models/nm-webs.interfaces';
import { ENmWebElementTypes } from '../../../shared/constants/nm-webs.enums';
import { getRelativePath, isExternalLink } from './sections.util';
import { TabData } from '../models';

export function parseCmsSectionToTabData(section?: NmWebSection): TabData[] {
  const elements = section?.nmWebElements ?? [];

  return elements
    .filter((el) => el.nmGenericType?.name === ENmWebElementTypes.ELEMENT_TAB)
    .map(({ content, redirectUrl, elementCheck }) => {
      const { icon, label } = extractIconAndLabelFromContent(content ?? '');

      const rawUrl = redirectUrl ?? '';
      const isExternal = isExternalLink(rawUrl);

      const useRouterLink = !isExternal && !elementCheck;

      return {
        icon,
        label,
        url: useRouterLink ? getRelativePath(rawUrl) : rawUrl,
        staticTab: false,
        useRouterLink,
        openExternally: !!elementCheck,
      };
    });
}

function extractIconAndLabelFromContent(content: string): { icon: string; label: string } {
  if (!content) return { icon: 'icon-', label: '' };

  const regex = /_(.*?)_/;
  const match = content.match(regex);

  if (!match) return { icon: 'icon-', label: content.trim() };

  const [fullMatch, iconName] = match;
  return {
    icon: `icon-${iconName}`,
    label: content.replace(fullMatch, '').trim(),
  };
}
